import * as React from 'react';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';

import css from './tanstack-query-devtools.css';


const TanstackQueryDevtools = () => (
  <div className={css.container}>
    <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
  </div>
);

export default TanstackQueryDevtools;
